import styled from 'styled-components';
import { theme, toRem } from 'design';
import { H4 } from '../Typography';

const PageLabel = styled(H4)`
  display: flex;
  flex-grow: 0;
  width: auto;
  font-size: ${toRem(11)};
  color: ${theme.color.neutral[400]};

  @media (min-width: ${theme.breakpoint.med}px) {
    font-size: ${toRem(13.25)};
  }
`;

export default PageLabel;
